import React, { memo } from 'react';

import IconButton from '@mui/material/IconButton';
import TooltipForButton from '@/components/mui/Tooltip/TooltipForButton';

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

import elements from '@/components/elements';

interface ExportButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
}

function ExportButton({ onClick, isDisabled = true }: ExportButtonProps) {
  return (
    <TooltipForButton
      t={{
        id: 'tooltip.export',
        defaultMessage: 'Export',
      }}
    >
      <IconButton color="primary" onClick={onClick} disabled={isDisabled} data-element={elements.history.export}>
        <FileDownloadOutlinedIcon />
      </IconButton>
    </TooltipForButton>
  );
}

export default memo(ExportButton);
